import React, { useRef } from 'react'

import './CustomInput.css'

export const CustomInput = (props) => {

  const changeHandler = (e) => {
    const { value } = e.target;
    props.onInput(value);
  }

  const inputId = useRef(Math.random());

  return (
    <div className='custom-input'>
      {
        props.value 
        ? <label htmlFor={inputId.current} className='custom-input__label'>{props.placeholder}</label>
        : null 
      }
      
      <input 
        id={inputId.current}
        type="text" 
        className={'custom-input__input ' + (props.value ? 'custom-input__input--text' : 'custom-input__input--empty') }
        placeholder={props.placeholder}
        value={props.value} onChange={changeHandler}/>
    </div>
  )
}
